import { isValidEmail } from './validation'
import { isMobileNumberValid, isValidString } from '@afterpay/utils'

interface CheckoutInitialiseLoginIdentifierData {
  crossRegionUserSignInEmail?: string
  checkoutEmail?: string | null // Merchant provided email from create checkout
  checkoutMobile?: string | null // Merchant provided mobile number from create checkout
  usernameFromCookie: string | null // Can be email or mobile number
}

interface CheckoutInitialiseLoginIdentifier {
  email: string
  mobileNumber: string
}

export const getValidUserEmailAndMobile = ({
  crossRegionUserSignInEmail,
  checkoutEmail,
  checkoutMobile,
  usernameFromCookie,
}: CheckoutInitialiseLoginIdentifierData): CheckoutInitialiseLoginIdentifier => {
  const cachedLoginIdentifier = usernameFromCookie ?? ''
  const isCachedLoginIdentifierValid = isValidString(cachedLoginIdentifier)
  const isCachedIdentifierValidEmail = isCachedLoginIdentifierValid && isValidEmail(cachedLoginIdentifier)
  const isCachedIdentifierValidMobile = isCachedLoginIdentifierValid && isMobileNumberValid(cachedLoginIdentifier)
  const isCrossRegionEmailValid = isValidEmail(crossRegionUserSignInEmail?.trim() ?? '')

  /**
   * Email Priority:
   * 1. Valid cross-region email
   * 2. Checkout email
   * 3. Valid cached email from cookie
   * 4. Empty string
   *
   * Mobile Priority:
   * 1. Checkout mobile number
   * 2. Valid mobile number from cookie
   * 3. Empty string
   */
  const cachedEmail = isCachedIdentifierValidEmail ? cachedLoginIdentifier : ''
  const checkoutEmailOrCachedEmail = isValidEmail(checkoutEmail ?? '') ? checkoutEmail : cachedEmail
  const parsedEmail = isCrossRegionEmailValid ? crossRegionUserSignInEmail : checkoutEmailOrCachedEmail

  const cachedMobile = isCachedIdentifierValidMobile ? cachedLoginIdentifier : ''
  const parsedMobile = isMobileNumberValid(checkoutMobile ?? '') ? checkoutMobile : cachedMobile

  return {
    email: parsedEmail?.trim() ?? '',
    mobileNumber: parsedMobile?.trim() ?? '',
  }
}
